<script lang="ts">
    import { get } from "svelte/store";
    import { Inputs } from "../models/Inputs";
    import { PdfValues } from "../models/PdfValues"; 
    import { QuoteResult } from "../models/QuoteResult";        
    import {setNames, showPdf } from "../services/ApplicationDataServices";
    import { FinProBaseUrl } from "../services/Store";
    import ResultBlock from "./controls/ResultBlock.svelte";
    import LeadForm from './LeadForm.svelte'
    
    export let result = new QuoteResult();  
    export let inputs = new Inputs(); 
    
    let showPopup = false;   
    
    let baseurl:String= get(FinProBaseUrl);
    let isValid:boolean=false;    
    let pdf:PdfValues = new PdfValues("","","","","","","","","");
     

    
    const onShowPopup = (ev) => {  
        let cookie = document.cookie.match(/^(.*;)?\s*estateMaxModalPDFForm\s*=\s*[^;]+(.*)?$/);       
        if(cookie){      
            setValues();
            showPdf(baseurl, pdf);                      
        }
        else{            
            showPopup = true;           
        }              
	}
    const onPopupClose = () => {
		showPopup = false;
	}
    const getPdf = () => {    
        setValues();       
        showPdf(baseurl, pdf);        
    }
    function setValues(){
        pdf.age = inputs.purchaseAge;  
        pdf.amount = result.single;
        pdf.calculatedBy = inputs.calculatedBy;
        pdf.illustrationDate = new Date().toJSON().slice(0,10);   
        pdf.gender = inputs.gender;         
        pdf.preparedFor = inputs.clientName;
        pdf.state = inputs.state; 
        pdf.chronicIllnessBenefit = result.chronicIllness;
        pdf.guaranteedDeathBenefit = result.guaranteedDeath;
        pdf.singlePremiumAmount = result.single;
        pdf.terminalConditionBenefit = result.terminalIllness;
    }
   
</script>
<div class="container content">
    <h1 class="cta">Calculated payout</h1>         
    <p class="subheader">Results for a {inputs.investmentAmount} investment paid out on a {inputs.calculatedBy} basis.</p>    
</div>   
<div class="container content">
    <div class="panel">
        <h1 class="header">Here's your client's calculated financial legacy and death benefit scenarios.</h1>
        <p class="subheader">Download and share a summary report with your client. Then, get them approved for Protective Series Estate Maximizer in 10 minutes or less with our simple Ten Minute Legacy sales process.</p>
        <ResultBlock label="Single Payment Amount" value={result.single} />
        <ResultBlock label="Guaranteed Death Benefit" value={result.guaranteedDeath} note='1' />
        <ResultBlock label="Chronic Illness Accellerated Death Benefit" value={result.chronicIllness} note='2'  />
        <ResultBlock label="Terminal Illness Accellerated Death Benefit" value={result.terminalIllness} note='3'  />
        <div class="link" on:click="{onShowPopup}">Download summary report</div> 
    </div> 
</div>
<div class="legalList">
    <p class="list">1 Loans, if not repaid, and accessed policy riders may reduce the policy’s death benefit and cash values. Riders are not available in all states. Withdrawals and loans are subject to tax on any gain in the contract, and if taken before age 59 1/2, may be subject to a 10% federal tax penalty.</p><br />
    <p class="list">2 The maximum Accelerated Death Benefit is shown. This benefit will be added to the contract at no additional charge. A minimum of 10% of the guaranteed death benefit must remain in force after the accelerated payment is made. An acceleration charge is added to the accelerated payment to determine the Total accelerated amount, which will reduce the death benefit by an amount greater than the accelerated payment. Receipt of the accelerated death benefit may affect eligibility for public assistance programs. The amount of accelerated death benefits cannot exceed the annual limits for payments that would be free of current federal income tax. Amounts received based on chronic illness may be considered taxable income if they exceed current IRS limits. Contract owners should consult their tax advisor regarding any tax implications. Subject to minimums and maximums, consult your policy for details. Availability and features may vary by state.</p><br />
    <p class="list">3 The maximum Accelerated Death Benefit is shown. A minimum of 10% of the guaranteed death benefit must remain in force after the accelerated payment is made. An acceleration charge is added to the accelerated payment to determine the Total accelerated amount, which will reduce the death benefit by an amount greater than the accelerated payment. Receipt of the accelerated death benefit may affect eligibility for public assistance programs. Contract owners should consult their tax advisor regarding any tax implications. Subject to minimums and maximums, consult your policy for details. Availability and features may vary by state.</p><br />
    <div>
        <p class="legalCopy">These calculations are for demonstration purposes only, and this calculator should not be relied upon for application values. Please consult the value statement to verify calculations before submitting an application.</p>
    </div>
</div>
<LeadForm   isValid={isValid}                
                open={showPopup} 
                onClosed={() => onPopupClose()}                          
                on:showPdf="{getPdf}"
        />  
        <style lang="scss">
            h1.cta{
                font-family: Open Sans;
                font-style: normal;
                font-weight: bold;
                font-size: 42px;
                line-height: 52px;
                text-align: center;
                margin-top:60px;
                margin-bottom:32px;
                @media(max-width:768px){
                    font-size: 26px;
                    line-height: 36px;
                    text-align: left;
                    margin-left: 20px;
                }
            } 
            h1.header{
                font-family: 'Open Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 18px;
                line-height: 32px;
                text-align: center;      
                margin: 16px auto;
                max-width: 567px;
                @media(max-width:992px){
                    font-size: 18px;
                    line-height: 32px;
                    text-align: left;
                    padding-left: 23px;         
                }
              
            }
            p.subheader{
                font-family: Open Sans;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 30px;     
                text-align: center;
                margin: 0px auto 32px;
                max-width: 567px;
                @media(max-width:992px){
                    font-size: 14px;
                    line-height: 18px;
                    text-align: left;
                    padding-left: 23px;            
                }      
            }
            .panel{    
                background-color: white;
                border: #C6C6C6 solid 1px;     
                margin-left: auto;                                      
                margin-right: auto;   
                margin-bottom: 40px;
                @media(max-width:992px){
                    display: inline-block;           
                }                      
            }
             .link{       
                font-family: Open Sans;
                font-size: 16px;
                font-weight: 600;
                line-height: 26px;
                letter-spacing: 0px;
                text-align: center;
                text-decoration-line: underline;
                color: #4C12A1;
                margin: 19px 8px 11px;       
                cursor:pointer;
            }
            p.list{
                font-family: Open Sans Condensed;
                font-size: 16px;
                font-weight: 300;
                line-height: 30px;
                letter-spacing: 0px;
                text-align: left;
                color:#000000;     
            }
            p.legalCopy{
                font-family: Open Sans Condensed;
                font-size: 16px;
                font-weight: 700;
                line-height: 30px;
                letter-spacing: 0px;
                text-align: left;
                color:#000000;
            }
            .legalList{       
                margin-left:115px;
                margin-right: 115px;
            }        
</style>
   
          

